import React from 'react'
import styled from 'styled-components'
import useResizeObserver from 'use-resize-observer'

import { DashboardContext } from 'live/context/dashboard'
import Utils from 'live/lib/utils'

import BowtieDetails from './components/BowtieDetails'
import HeaderCard from './components/BowTieMobile/HeaderCard'
import ListBowTieCard from './components/BowTieMobile/ListBowTieCard'
import ThumbnailCard from './components/BowTieMobile/ThumbnailCard'
import DetailsInfo from './components/DetailsInfo'
import { useBowTieTypes } from './hooks'
import { resizeY, changeDashboard, addStyleContainerWidget } from './utils'

interface Props {
    ships: any
    scenarios: any
    event: any
    height: any
    widget: LiveWidgetOnContext
}

const MobileBowtie = ({ ships, scenarios, event, height, widget }: Props): JSX.Element => {
    const [expand, setExpand] = React.useState(false)
    const [stateHeight, setStateHeight] = React.useState(0)
    const [showDetails, setShowDetails] = React.useState(false)
    const [showInfo, setShowInfo] = React.useState(false)
    const [active, setActive] = React.useState<null | number>(null)

    const [dataInfoDetails, setDataInfoDetails] = React.useState({})
    const [dataListDetails, setDataListDetails] = React.useState({ json: {}, event: {} })
    const [dataThumbnail, setDataThumbnail] = React.useState({
        scenario: {},
        type: ''
    })
    const [dataHeader, setDataHeader] = React.useState({
        rig: '',
        id: '',
        rigManager: '',
        status: '',
        totalBarriers: undefined,
        totalBarriersDegraded: undefined
    })

    const heightRef = React.useRef(null)
    const reactGridLayoutHeight = React.useRef(0)
    const reactGridLayoutElRef = React.useRef(null)

    const dashboardContext = React.useContext(DashboardContext)

    const { ref, width: obsWidth = 300, height: obsHeight = 400 } = useResizeObserver<HTMLDivElement>()
    const ismobile = Utils.isMobile()
    const mode = ismobile ? 'phone' : 'desktop'
    const viewMode = window.location.hash.includes('dashboard')
    const bowtieTypes = useBowTieTypes(ships, scenarios, event)

    React.useEffect(() => {
        if (event) {
            const { siteId } = event
            const dataShip = ships.filter((e, i) => e.title.replace(' ', '') === siteId)[0]

            const totalDegraded = Object.keys(bowtieTypes?.TYPEOPTIONS)?.reduce(
                (acc, curr) => acc + bowtieTypes?.TYPEOPTIONS[curr]?.deprecated,
                0
            )
            const totalBarriers = bowtieTypes?.allDataBowtie.reduce((acc, curr) => acc + curr?.barriersTotal, 0)

            heightRef.current = heightRef.current ? heightRef.current : height

            siteId &&
                setDataThumbnail({
                    ...dataThumbnail,
                    ...bowtieTypes,
                    scenario: scenarios[siteId],
                    type: dataShip?.type
                })

            setDataHeader({
                ...dataHeader,
                rig: dataShip?.title,
                id: dataShip?.id,
                rigManager: dataShip?.rigManager,
                status: dataShip?.status,
                totalBarriers: totalBarriers,
                totalBarriersDegraded: totalDegraded
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event, bowtieTypes, scenarios, ships, obsHeight, height])

    React.useEffect(() => {
        if (widget && widget.id) {
            const id = String(widget.id)

            if (viewMode) {
                const timer = setInterval(() => {
                    if (id) {
                        clearInterval(timer)
                        setStateHeight(dashboardContext?.dashboard?.jsonConfig?.layoutModes[mode].grid[id].size_y)
                        const reactGridLayoutEl = document.getElementsByClassName('react-grid-layout')[0]
                        reactGridLayoutHeight.current =
                            parseInt(reactGridLayoutEl.getAttribute('style').match(/\d+/)[0]) + 90
                        reactGridLayoutElRef.current = reactGridLayoutEl
                    }
                }, 500)

                const timer2 = setInterval(() => {
                    addStyleContainerWidget(widget?.id)
                    changeDashboard(dashboardContext, mode)
                    reactGridLayoutElRef?.current &&
                        reactGridLayoutElRef.current.setAttribute(
                            'style',
                            `height: ${reactGridLayoutHeight.current}px;`
                        )
                    clearInterval(timer2)
                }, 300)
            }
        }
    }, [])

    const handlerClick = (idx: number, amountItens: number): void => {
        setExpand(!expand)
        setActive(idx === active ? null : idx)
        const decision = expand && !!(idx === active)
        const h = heightRef.current + 70 + amountItens * 32

        setTimeout(() => {
            resizeY(dashboardContext, mode, widget.id, !decision ? h : stateHeight, decision)
        }, 300)
    }

    const handlerShowDetails = (ev: React.MouseEvent<HTMLElement>, id, key: string, index: number): void => {
        const btListdata = bowtieTypes?.allDataBowtie.filter(e => e?.id === id)[0]
        const btListdataAnotherData = event?.bowTie.filter(e => e?.bowtieId === id)[0]

        setDataListDetails({ json: btListdata, event: btListdataAnotherData })
        setShowDetails(!showDetails)
    }
    const handlerShowInfo = (ev: React.MouseEvent<HTMLElement>, data: number): void => {
        setDataInfoDetails(data)
        setShowInfo(!showInfo)
    }

    return (
        <MobileBowtieContainer ref={ref} height={height} show={showDetails} showInfo={showInfo}>
            <div className="BowtieMobile_pages BowtieMobile_page_1">
                <div className="MobileBowtie__top">
                    <HeaderCard data={dataHeader} />
                </div>
                <div className="MobileBowtie__middle">
                    <ThumbnailCard event={dataThumbnail} />
                </div>
                <div className="MobileBowtie__bottom">
                    {Object.keys(bowtieTypes.TYPEOPTIONS).map((e, i) => {
                        return (
                            <React.Fragment key={i}>
                                <ListBowTieCard
                                    name={e}
                                    setShowDetails={handlerShowDetails}
                                    expand={i === active}
                                    onClick={(ev, amountItens: number) => handlerClick(i, amountItens)}
                                    event={bowtieTypes.TYPEOPTIONS[e]}
                                />
                            </React.Fragment>
                        )
                    })}
                </div>
            </div>
            <div className="BowtieMobile_pages BowtieMobile_page_2">
                <BowtieDetails
                    data={dataListDetails}
                    goBack={ev => {
                        ev.stopPropagation()
                        setShowDetails(!showDetails)
                    }}
                    toInfo={handlerShowInfo}
                    handlerClick={(ev, i, amountItens) => handlerClick(i, amountItens)}
                />
            </div>
            <div className="BowtieMobile_pages BowtieMobile_page_3">
                <DetailsInfo data={dataInfoDetails} goBack={() => setShowInfo(!showInfo)} />
            </div>
        </MobileBowtieContainer>
    )
}

export default MobileBowtie

const MobileBowtieContainer = styled.div<{ height: number; show: boolean; showInfo: boolean }>`
    &,
    * {
        box-sizing: border-box;
    }

    height: ${props => props?.height}px;
    background: #DDDEE1;
    position: relative;

    &,
    .BowtieMobile_page_1 .MobileBowtie__top,
    .BowtieMobile_page_1 .MobileBowtie__middle,
    .BowtieMobile_page_1 .MobileBowtie__bottom,
    .BowtieMobile_pages {
        margin: 0;
        padding: 0;
    }
    .BowtieMobile_pages {
        position: absolute;
        width: 100%;
        height: 100%;
        transition: 0.5s all ease-in-out;
        /* opacity: ${({ show }) => (show ? 1 : 0)}; */
    }

    .BowtieMobile_page_1 {
        left: ${({ show }) => (show ? 'calc(100%*2*-1)' : 0)};
    }
    .BowtieMobile_page_2 {
        left: ${({ show, showInfo }) =>
            show && !showInfo ? 0 : show && showInfo ? 'calc(100%*2*-1)' : 'calc(100%*2)'};
    }
    .BowtieMobile_page_3 {
        left: ${({ showInfo }) => (showInfo ? 0 : 'calc(100%*2)')};
    }
    .BowtieMobile_page_1 .MobileBowtie__top {}
    .BowtieMobile_page_1 .MobileBowtie__middle {
        margin: 8px 0;
    }
    .BowtieMobile_page_1 .MobileBowtie__bottom {
        display: flex;
        flex-direction: column;
        height: 100%;

        .ListBowTieCard {
            cursor: pointer;
        }
        
        .ListBowTieCard:not(:last-child) {
            margin-bottom: 8px;
        }
    }


`
